import React from "react";
import FilterContext from "../../../routes/FilterContext";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import KeyDates from "./KeyDates";
import UnitAndRents from "./UnitAndRents";
import TermDetails from "./TermDetails";
import CarParks from "./CarParks";
import AssetCustom from "./AssetCustom";
import SectorCustom from "./SectorCustom";
import LeaseAnalysis from "./LeaseAnalysis";
import LeaseDeed from "./LeaseDeed";
class CustomTabs extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Tabs>
        <TabList>
          <Tab>Summary</Tab>
          <Tab>Key Dates</Tab>
          <Tab>Units & Rents</Tab>
          <Tab>Term Details</Tab>
          <Tab>Car Parks</Tab>
          <Tab>Assets</Tab>
          <Tab>Sector</Tab>
          <Tab>Lease Analysis</Tab>
          <Tab>Lease Deed</Tab>
        </TabList>

        <TabPanel>
          <div className="widget">
            <div className="container-fluid p-0 aseetContent mapsUl">
              <div className="row">
                <div className="row">
                  <div className="col-lg-12 text-start mb-3">
                    <h5>Lease Summary</h5>
                  </div>
                </div>
                <div className="col-lg-6">
                  <ul className="detailsUl">
                    <li className="">
                      <span>Unit Address</span>
                      <span>{this.props.address}</span>
                    </li>
                    <li className="liBlueBg">
                      <span>Lessor</span>
                      <span>{this.props.leaseSummary.lessor}</span>
                    </li>
                    <li className="liBlueBg">
                      {" "}
                      <span>Lessee</span>
                      <span>{this.props.leaseSummary.lesse}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Chargeable Area</span>
                      <span>{this.props.leaseSummary.chargeable_area}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Lease Term</span>
                      <span>{this.props.leaseSummary.lease_term}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Absorption Date</span>
                      <span>{this.props.leaseSummary.absorption_date}</span>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul className="detailsUl">
                    <li>
                      {" "}
                      <span>Type</span>
                      <span>{this.props.leaseSummary.type}</span>
                    </li>
                    <li className="">
                      <span>Space Type</span>
                      <span>{this.props.leaseSummary.space_type}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Agreement Type</span>
                      <span>{this.props.leaseSummary.agreement_type}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Carpet Area</span>
                      <span>{this.props.leaseSummary.carpet_area}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Floors</span>
                      <span>{this.props.leaseSummary.floor_number}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Effective Rent (₹/sqft/month)</span>
                      <span>{this.props.leaseSummary.effective_rent}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <KeyDates />
        </TabPanel>
        <TabPanel>
          <UnitAndRents />
        </TabPanel>
        <TabPanel>
          <TermDetails />
        </TabPanel>
        <TabPanel>
          <CarParks />
        </TabPanel>
        <TabPanel>
          <AssetCustom />
        </TabPanel>
        <TabPanel>
          <SectorCustom />
        </TabPanel>
        <TabPanel>
          <LeaseAnalysis />
        </TabPanel>
        <TabPanel>
          <LeaseDeed />
        </TabPanel>
      </Tabs>
    );
  }
}

export default CustomTabs;
